import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { InfisicalAPI, infisicalApiRef } from './api/InfisicalApi';

export const infisicalPlugin = createPlugin({
  id: 'infisical',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: infisicalApiRef,
      deps: { fetchApi: fetchApiRef, configApi: configApiRef },
      factory: ({ fetchApi, configApi }) => new InfisicalAPI({ fetchApi, configApi }),
    }),
  ],
});

export const InfisicalSecretsPage = infisicalPlugin.provide(
  createRoutableExtension({
    name: 'InfisicalSecretsPage',
    component: () =>
      import('./components/WrapperComponent').then(m => m.WrapperComponent),
    mountPoint: rootRouteRef,
  }),
);
